import { api } from '@/modules/helper';

export default {
  namespaced: true,

  state: {
    items: [],
  },

  mutations: {},

  getters: {},

  actions: {
    create(state, payload) {
      return api.post(`user/rewards/${payload.userId}`, payload.data);
    },

    redeem(state, payload) {
      return api.post(`user/redeem/${payload.userId}/${payload.redeemableId}`);
    },
  },
};
